import { DEFAULT_STATUS_MESSAGE } from '@unified-ui/utilities';
import type { IStatusPanelComp } from 'ag-grid-community';

export class StatusBarMessageComponent implements IStatusPanelComp {
    eGui!: HTMLDivElement;
    // Message on the panel
    public message: string = DEFAULT_STATUS_MESSAGE;

    init() {
        this.eGui = document.createElement('div');
        this.eGui.classList.add('grid-status-bar-message');
        this.eGui.innerHTML = `<i class="pi pi-info-circle"></i><span class="text-area">${this.message}</span>`;
    }

    getGui() {
        return this.eGui;
    }

    public setMessage(message: string) {
        this.message = message;
        this.eGui.querySelector('span')!.textContent = message;
    }
}
